import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSearch } from "react-icons/fa";
import {
  Collapse,
  Navbar,
  Button,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from "reactstrap";
import SignIn from "./signIn";
import SignUp from "./signUp";

function Navv() {
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => setCollapsed(!collapsed);

  const [opened, change] = useState(false);

  const [isLogin, changeForm] = useState(true);

  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") !== null
  );

  const history = useHistory();

  const modalStyle = {
    display: opened ? "block" : "none",
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0,0,0,.5)",
    position: "fixed",
    top: 0,
    left: 0,
    color: "white",
    zIndex: "1000 !important",
  };
  const clicked = () => {
    change(!opened);
  };

  const toLogin = () => {
    changeForm(true);
  };
  const toSignUp = () => {
    changeForm(false);
  };
  const closeModal = () => {
    change(false);
  };
  const signout = () => {
    localStorage.removeItem("token");
    // localStorage.removeItem("email");
    setLoggedIn(false);

    console.log("sign out done");
    history.push("/");
  };
  const forin = {
    display: loggedIn ? "none" : "block",
  };
  const forout = {
    display: loggedIn ? "block" : "none",
  };
  return (
    <div>
      <Navbar color="faded" light expand="md">
        <NavbarBrand
          href="/"
          className="mr-auto"
          style={{ fontWeight: "bolder" }}
        >
          {" "}
          <img
            style={{ width: "90px", height: "90px", borderRadius: "50%" }}
            src="https://i.pinimg.com/originals/08/17/15/0817158f3a05c0d62de647c28f4cde54.jpg"
            alt="Logo"
          />
          <span
            style={{
              fontSize: "29px",
              fontWeight: "bolder",
              textShadow: "9px 6px purple",
            }}
          >
            N{" "}
          </span>
          ex
          <span
            style={{
              fontSize: "25px",
              fontWeight: "bolder",
              textShadow: "8px 5px brown",
            }}
          >
            T{" "}
          </span>
          agram
        </NavbarBrand>

        <NavbarToggler onClick={toggleNavbar} className="mr-2" />

        <Collapse className="justify-content-end" isOpen={!collapsed} navbar>
          <Nav navbar>
            <Button className="mx-2" onClick={signout} style={forout}>
              Sign out
            </Button>
            <NavItem>
              <Button className="mx-2" color="secondary">
                <Link to="/" style={{ color: "yellow" }}>
                  Users{" "}
                </Link>
              </Button>
            </NavItem>
            <NavItem>
              {loggedIn ? (
                <Button className="mx-2" color="success">
                  <Link to="/myProfile" style={{ color: "yellow" }}>
                    My Profile
                  </Link>
                </Button>
              ) : (
                // <link style={{ color: "yellow" }}>My Profile </link>
                <Button
                  className="mx-2"
                  color="secondary"
                  onClick={clicked}
                  style={forin}
                >
                  -My Profile-
                </Button>
              )}
            </NavItem>
            <NavItem>
              <form className="mx-2">
                <input type="text" placeholder="search...." />
                <Button type="button">
                  <FaSearch />
                </Button>
              </form>
            </NavItem>
            <NavItem>
              <Button
                className="ml-4 mr-2"
                color="secondary"
                onClick={clicked}
                style={forin}
              >
                SignIn/SignUp
              </Button>
              <div style={modalStyle}>
                {isLogin ? (
                  <div
                    style={{
                      zIndex: "1000",
                      width: "50%",
                      margin: "auto",
                      color: "black",
                      backgroundColor: "white",
                      padding: "5px",
                      marginTop: "80px",
                      border: "2px solid black",
                      borderRadius: "10px",
                    }}
                  >
                    <button onClick={closeModal}>X</button>
                    <h1>Login</h1>
                    <SignIn setLoggedIn={setLoggedIn} closeModal={closeModal} />
                    <Button color="success" onClick={toSignUp}>
                      New member? Sign up here
                    </Button>
                  </div>
                ) : (
                  <div
                    style={{
                      width: "50%",
                      margin: "auto",
                      color: "black",
                      backgroundColor: "white",
                      padding: "5px",
                      marginTop: "80px",
                      border: "2px solid black",
                      borderRadius: "10px",
                    }}
                  >
                    <button onClick={closeModal}>X</button>
                    <h1>Sign Up</h1>
                    <SignUp />
                    <Button color="success" onClick={toLogin}>
                      Already a member?Login here
                    </Button>
                  </div>
                )}
              </div>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}
export default Navv;
